export enum TriggerLogicType {
  CROSSED,
  TOUCHED,
  THROUGH,
}

export namespace TriggerLogicType {
  let elements = [TriggerLogicType.CROSSED, TriggerLogicType.TOUCHED, TriggerLogicType.THROUGH];
  let alias = "com.bcdfx.model.TriggerLogicType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
